export enum BADGE_TYPES {
  error = 'error',
  warning = 'warning',
  info = 'info',
  success = 'success',
  default = 'default',
}

export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm'

export const DAYS_IN_WEEK = 7
